export default {
  // Tiêu đề trang
  title: "Cấu hình tự động đẩy",
  
  // Biểu mẫu tìm kiếm
  searchForm: {
    pushTitle: "Tiêu đề đẩy",
    pushTitlePlaceholder: "Vui lòng nhập",
    language: "Ngôn ngữ",
    languagePlaceholder: "Vui lòng chọn",
    pushSwitch: "Công tắc đẩy",
    pushSwitchPlaceholder: "Vui lòng chọn",
    search: "Tìm kiếm",
    reset: "Đặt lại",
    add: "Thêm mới"
  },
  
  // Tiêu đề cột bảng
  table: {
    pushType: "Loại đẩy",
    subType: "Loại con",
    pushTitle: "Tiêu đề đẩy",
    pushContent: "Nội dung đẩy",
    jumpPath: "Đường dẫn chuyển hướng",
    language: "Ngôn ngữ",
    pushSwitch: "Công tắc đẩy",
    inboxPushSwitch: "Công tắc tin nhắn hộp thư",
    inboxMessageType: "Loại tin nhắn hộp thư",
    operation: "Thao tác",
    edit: "Chỉnh sửa",
    delete: "Xóa"
  },
  
  // Các loại đẩy
  pushTypes: {
    recharge: "Nạp tiền",
    withdrawal: "Rút tiền",
    vipReward: "Thưởng VIP",
    activityOffer: "Ưu đãi hoạt động",
    kyc: "KYC"
  },
  
  // Các loại con
  subTypes: {
    onlineRecharge: "Nạp tiền trực tuyến",
    manualRecharge: "Nạp tiền thủ công",
    onlineWithdrawal: "Rút tiền trực tuyến",
    manualWithdrawal: "Rút tiền thủ công",
    upgradeBonus: "Thưởng nâng cấp",
    retentionBonus: "Thưởng giữ cấp",
    weeklySalary: "Lương tuần",
    monthlySalary: "Lương tháng",
    birthdayBonus: "Thưởng sinh nhật",
    kycVerification: "Xác minh KYC",
    manualRechargePoints: "Cộng điểm thủ công",
    manualDeductPoints: "Trừ điểm thủ công",
    upgradePoints: "Điểm nâng cấp",
    retentionPoints: "Điểm giữ cấp",
    h5DailyPoints: "Điểm hằng ngày H5",
    appDailyPoints: "Điểm hằng ngày App",
    bettingRebate: "Hoàn tiền cược",
    realtimeRebate: "Hoàn tiền tức thời",
    registrationOffer: "Ưu đãi đăng ký",
    dailyFirstDeposit: "Nạp đầu mỗi ngày",
    rechargeOffer: "Ưu đãi nạp tiền",
    manualIssue: "Phát thủ công",
    everyDepositOffer: "Ưu đãi mỗi lần nạp",
    firstDepositOffer: "Ưu đãi nạp đầu"
  },
  
  // Trạng thái công tắc đẩy
  pushSwitch: {
    enabled: "Bật",
    disabled: "Tắt"
  },
  
  // Modal
  modal: {
    addTitle: "Thêm mới",
    editTitle: "Chỉnh sửa",
    pushType: "Loại đẩy",
    pushTypePlaceholder: "Vui lòng chọn",
    subType: "Loại con",
    subTypePlaceholder: "Vui lòng chọn",
    notificationTitle: "Tiêu đề thông báo",
    notificationTitlePlaceholder: "Trong vòng 50 ký tự",
    memberType: "Loại thành viên",
    memberTypePlaceholder: "Vui lòng chọn loại thành viên",
    loginChannel: "Kênh đăng nhập",
    loginChannelPlaceholder: "Vui lòng chọn",
    notificationContent: "Nội dung thông báo",
    notificationContenttips: ' (Nếu nội dung đẩy liên quan đến số tiền hoặc biến khác, vui lòng sử dụng định dạng {0} để thêm)',
    notificationContentPlaceholder: "Trong vòng 1000 ký tự",
    selectLanguage: "Chọn ngôn ngữ",
    languagePlaceholder: "Vui lòng chọn",
    jumpPath: "Đường dẫn chuyển hướng",
    jumpPathPlaceholder: "Vui lòng nhập đường dẫn chuyển hướng",
    pushSwitch: "Công tắc đẩy",
    inboxPushSwitch: "Công tắc đẩy tin nhắn hộp thư",
    inboxMessageType: "Loại tin nhắn hộp thư",
    inboxMessageTypePlaceholder: "Vui lòng chọn loại tin nhắn hộp thư",
    enable: "Bật",
    disable: "Tắt",
    confirm: "Xác nhận",
    cancel: "Hủy"
  },
  
  // Thông báo xác thực
  validation: {
    pushTypeRequired: "Vui lòng chọn loại đẩy",
    subTypeRequired: "Vui lòng chọn loại con",
    notificationTitleRequired: "Vui lòng nhập tiêu đề thông báo",
    notificationContentRequired: "Vui lòng nhập nội dung thông báo",
    notificationContentPattern: "Nội dung thông báo phải bao gồm định dạng {0-9}",
    languageRequired: "Vui lòng chọn ngôn ngữ",
    inboxMessageTypeRequired: "Vui lòng chọn loại tin nhắn hộp thư"
  },
  
  // Gửi theo lịch (tất cả thành viên)
  schedule: {
    title: "Cài đặt gửi theo lịch",
    sendDate: "Ngày gửi tự động",
    sendDateRequired: "Vui lòng chọn ngày gửi tự động",
    dailyTime: "Giờ gửi hàng ngày",
    dailyTimeRequired: "Vui lòng chọn giờ gửi hàng ngày",
    fillWarning: "Vui lòng điền ngày gửi tự động và giờ gửi hàng ngày"
  },

  // Thông báo thao tác
  messages: {
    addSuccess: "Thêm thành công",
    updateSuccess: "Cập nhật thành công",
    deleteSuccess: "Xóa thành công",
    deleteFailed: "Xóa thất bại",
    fetchDataFailed: "Không thể tải dữ liệu",
    confirmDelete: "Xác nhận xóa",
    confirmDeleteContent: "Bạn có chắc chắn muốn xóa cấu hình đẩy \"{title}\" không?"
  }
};
